import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationCreatePlan = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, dataToSend }) => {
            return client.post(replaceParameters(PLANS.COLLECTION.url,
                {
                    organizationId: organizationId
                }
            ), dataToSend);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreatePlan;